import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IPADAgreenmentToolbar {
	isSubmitting: boolean;
	onSaveButtonClickHandler: () => void
	uploadIdsButtonClickHandler: () => void
	onBackToAccountSetupButtonClickHandler: () => void
	onPauseButtonClickHandler: () => void
	downloadButtonClickHandler: () => void
	accountantBankDetailsForPADData: any
}

export const PADAgreenmentToolbar: FC<IPADAgreenmentToolbar> = ({
	isSubmitting = false,
	onSaveButtonClickHandler,
	uploadIdsButtonClickHandler,
	onBackToAccountSetupButtonClickHandler,
	accountantBankDetailsForPADData,
	onPauseButtonClickHandler,
	downloadButtonClickHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#fff",
				// marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				bottom: 0,
			}}
		>
			<Toolbar>
				<>
					{/* {accountantBankDetailsForPADData && accountantBankDetailsForPADData.totalPreviousBanks !== 0 &&  */}
					{accountantBankDetailsForPADData && !accountantBankDetailsForPADData.padStatus && accountantBankDetailsForPADData && accountantBankDetailsForPADData.totalPreviousBanks === 0 &&
						<EnhancedButtonPrimeReact
							label="Back To Account Setup"
							raised
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							onClickHandler={onBackToAccountSetupButtonClickHandler}
						/>
					}
					{accountantBankDetailsForPADData && !accountantBankDetailsForPADData.padStatus && <EnhancedButtonPrimeReact
						label="Save"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
						onClickHandler={onSaveButtonClickHandler}
						style={{ marginLeft: "1rem" }}
					/>}
					{accountantBankDetailsForPADData && !accountantBankDetailsForPADData.padStatus && <EnhancedButtonPrimeReact
						label="Send for Verification"
						loading={isSubmitting}
						type="submit"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
						style={{ marginLeft: "1rem" }}
					/>}
					<EnhancedButtonPrimeReact
						label="Download"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						onClickHandler={downloadButtonClickHandler}
						style={{ marginLeft: "1rem" }}
						disabled={accountantBankDetailsForPADData && !accountantBankDetailsForPADData.padStatus}
					/>
					<EnhancedButtonPrimeReact
						label="Upload IDs"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						onClickHandler={uploadIdsButtonClickHandler}
						style={{ marginLeft: "1rem" }}
						disabled={accountantBankDetailsForPADData && !accountantBankDetailsForPADData.padStatus}
					/>
					{accountantBankDetailsForPADData && accountantBankDetailsForPADData.totalPreviousBanks !== 0 && <EnhancedButtonPrimeReact
						label="Pause"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Danger}
						onClickHandler={onPauseButtonClickHandler}
						style={{ marginLeft: "1rem" }}
					/>}
				</>
			</Toolbar>
		</AppBar>
	);
};
